import ConfigurationService, { ConfigurationKeys } from 'services/ConfigurationService';


const WEBCHAT_HOST = ConfigurationService.get(ConfigurationKeys.WEB_CHAT_HOST);

/* eslint-disable no-undef, max-len */
export const PRIVATE_SHOW_ACTION_URL = `${WEBCHAT_HOST}privateShowAction?userName={username}`;
export const GUEST_CHAT_REQUEST_URL = `${WEBCHAT_HOST}requestAccess?r={rnd}&roomname={roomName}`;
export const AUTHENTICATED_CHAT_REQUEST_URL = `${GUEST_CHAT_REQUEST_URL}&accessHash={accessHash}&username={username}&pass={pass}`;
export const WEBCHAT_POST_MESSAGE_MAIN_CHAT = `${WEBCHAT_HOST}writeMessage`;
export const CHAT_SETTINGS_URL = `${WEBCHAT_HOST}chatSettings`;
export const WEBCHAT_POST_MESSAGE_PRIVATE_CHAT = `${WEBCHAT_HOST}writePrivateMessage`;
